/* eslint-disable */
const getters = {
  getPostCategory(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
